// StableSurfaces Dependent (docs/stable-surfaces/model.md). Browser code reaches it: runtime imports crypto-free only.
import { parseDefinitionId } from './id.ts'

/** D8: the page root definition's id. */
export const PAGE_ROOT_DEFINITION_ID = parseDefinitionId('qa-page-root')
